import Account from 'models/account';
import qconsole from 'scripts/lib/qconsole';

export default class VgsAccountGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onFetchAllSuccess(vgsAccountDtos) {
    if (vgsAccountDtos) {
      vgsAccountDtos.forEach(dto => {
        const account = Account.fromJs(dto);
        this.context.stores.accounts.addOrReplace(account);
      });
    }
  }

  onFetchAllError(error) {
    qconsole.error('error fetching vgs account', error);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/channels/vgs_account_gateway_observer.js